<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a *ngIf="this.loginPersonType == 'EMPLOYEE'">Material</a><a *ngIf="this.loginPersonType != 'EMPLOYEE'">Inventory Control</a></li>
          <li><a>Payment Transactions</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->
    <div class="block">
      <div class="page-header">
        <span class="page-header__title">Payment Transactions</span>
      </div>
      <div class="Reports_form_div">
        <form class="form-horizontal" id="myForm" role="form" [formGroup]="registerForm">
          <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
            <mat-form-field appearance="outline" class="w-100" floatLabel="always" *ngIf="loginPersonType == 'EMPLOYEE'">
              <mat-label>Search Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield" placeholder="Search business" (keyup)="filterBusinesses($event)" (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities" [matAutocomplete]="businessAuto"
              />
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
              <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                <i *ngIf="f.businessfield.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Farm Site</mat-label>
              <mat-select id="location" formControlName="locationField" name="location" (click)="isDropdownOpen = false" [(ngModel)]="vendorDue.farm_site_id">
                <mat-option value="undefined" disabled>Select Farm site</mat-option>
                <mat-option *ngFor="let farmsite of farmsites" [value]="farmsite.id">
                  {{ (farmsite?.farmNameAtLocation) }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
              <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                <i *ngIf="f.locationField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
          </div>
        </form>
        <div class="buttons-div reports_search_div">
          <div class="transactions-button-container" (click)="getPaymentTransactions()">
            <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
              <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
              <span class="text">Search</span>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="!pgLoad">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="reports_block" *ngIf="pgLoad && isSubmitClicked">
        <div class="actions-container">
          <div class="search-div">
            <img src="../../../../../assets/images/New_Icons/search-icon.svg">
            <input type="text" (keyup)="onFiltersApplied('Search')" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by vendor name and vendor site">
            <button *ngIf="this.search != ''" type="button" (click)="clearFilters('search')" title="clear search" class="searchClose">&times;
            </button>
          </div>
          <div class="action-icons" *ngIf="vendorDues?.length > 0">
            <img src="../../../../assets/images/New_Icons/excel-download-icon.svg" title="Excel downlaod" (click)="exportExcel()">
            <img src="../../../../assets/images/New_Icons/expand-icon.svg" title="Zoom in" (click)="openFullScreen()">
          </div>
        </div>
        <div class="table-responsive" id="zoomView" *ngIf="vendorDues?.length > 0">
          <table class="table table-striped table-bordered table-hover text-centre">
            <thead>
            <tr>
              <th>S.No</th>
              <th class="handSymbol" (click)="sortingTransaction('name')">Vendor Name
                <span class="glyphicon sort-icon" [ngClass]="{'glyphicon-chevron-up':nameAsc,'glyphicon-chevron-down':!nameAsc}"></span>
              </th>
              <th>Vendor Site</th>
              <th>Last Payout Date</th>
              <th>Total Paid</th>
              <th>Total Due</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let list of vendorDues; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ (list && list.Vendor == null) ? 'NA' : (list && list.Vendor && list.Vendor.name) }}</td>
              <td>{{ (list && list.Vendor == null) ? 'NA' : (list && list.Vendor && list.Vendor.site) }}</td>
              <td>{{ (list?.VendorPaymentTransactions?.date | date: 'dd MMM yyyy') || 'NA' }}</td>
              <td>{{ list && list.paid_amount | currencyFormat }}</td>
              <td>{{ list && list.unpaid_amount | currencyFormat }}</td>
              <td>
                <button type="button" class="pay-button" *ngIf="list && list.unpaid_amount != 0" (click)=" addPaymentTransaction(list)"><span class="icon"><img
                  src="../../../../../assets/images/New_Icons/pay.svg" width="25"></span>
                  <span class="text">Pay</span>
                </button>
                <button type="button" class="view-button" (click)="viewDetailsBySelectedRow(list.id)" data-toggle="modal" data-target="#viewDetailsModal"><span class="icon"><img
                  src="../../../../../assets/images/New_Icons/view-icon.svg" width="17"></span>
                  <span class="text">View</span>
                </button>
              </td>
            </tr>
            <tr *ngIf="vendorDues.length > 0">
              <td></td>
              <td></td>
              <td></td>
              <td class="totalTxt">Total</td>
              <td class="totalfarmspend" style="font-weight: 500; font-size: 20px;">₹ {{ totalPaidAmount && totalPaidAmount | currencyFormat }}
              </td>
              <td class="tfsvalue" style="font-weight: 500; font-size: 20px;">₹ {{ totalUnpaidAmount && totalUnpaidAmount | currencyFormat}}
              </td>
              <td colspan="1"></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="vendorDues?.length === 0 && search && search.trim() !== '' && isSubmitClicked" class="noDataFoundMessage">
          No items match your search
        </div>
      </div>
      <!-- Show 'Data Not Available' when no data and no search -->
      <div *ngIf="vendorDues?.length === 0 && (!search || search.trim() === '') && isSubmitClicked" class="noDataFoundMessage">
        Data Not Available
      </div>
    </div>
    <!-- END FORM VALIDATION STATES -->
    <!--pay button details modal popup-->
    <!--add/update form-->
    <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
      <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
      <!--outside close-->
      <div class="popup-wrapper">
        <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
        <!-- Actual Popup -->
        <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
          <form [formGroup]="paymentRegisterForm" novalidate>
            <div class="form-header">
              <div class="form-title">Payment Details</div>
              <button class="add-update-submit-button" (click)="updateVendorDuePayment()" [disabled]="paymentsubmitteddisabled">
                <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg"></span>
                <span class="text">Submit</span>
              </button>
            </div>
            <div class="form-container">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Paid Date</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="fromDateField" [formControl]="transactionDateControl" placeholder="Choose date" autocomplete="off" readonly
                [max]="maxDate"/>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Amount</mat-label>
                <input matInput id="unpaidamount" type="text" formControlName="unpaidamount" name="amount" [(ngModel)]="paymenttransaction.paid_amount" autocomplete="off" placeholder="Enter amount" />
                <!-- Hint -->
                <mat-hint><i>Only numbers allowed</i></mat-hint>
                <mat-error *ngIf="(f1.unpaidamount.dirty || f1.unpaidamount.touched || paymentsubmitted) && f1.unpaidamount.errors">
                  <i> {{ f1.unpaidamount.hasError('required') ? 'Required.' : f1.unpaidamount.hasError('pattern') ? 'Only numbers are allowed.' : '' }}</i>
                </mat-error>
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--add/update form end-->
    <!--pay button modal popup end-->
    <!-- Modal -->
    <div id="viewDetailsModal" class="modal fade" role="dialog" data-backdrop="static">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" id="modalContent">
          <div class="modal-header">
            <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;
            </button>
            <h4 class="modal-title payment-title"><b>Invoice Details
              -- {{ viewDetails && viewDetails.Vendor && viewDetails.Vendor.name }} as of {{ transactionDate }}</b></h4>
          </div>
          <div class="modal-body">
            <div class="row" [ngClass]="{'itemScroll' : viewDetails && viewDetails.invoiceItems.length > 7}">
              <div class="panel-body table-responsive">
                <table class="table table-bordered table-hover">
                  <thead>
                    <tr class="itemsheading">
                      <th>Invoice Details</th>
                      <th>Item</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>

                  <tbody>
                    <ng-container *ngFor="let data of viewDetails?.invoiceItems">
                      <!-- First item row includes the invoice number -->
                      <tr class="invoice-group-start">
                        <td [attr.rowspan]="data?.Items?.length" class="invoiceNumber">
                          {{ data?.Invoice || 'NA' }}
                        </td>
                        <td>
                          {{ data.Items[0]?.ItemName }}
                          <span *ngIf="data.Items[0]?.sub_type">- {{ data.Items[0]?.sub_type }}</span>
                        </td>
                        <td>{{ data.Items[0]?.quantity }} {{ data.Items[0]?.uom }}</td>
                      </tr>
                      <!-- Remaining items (if more than one) -->
                      <tr *ngFor="let item of data.Items.slice(1)">
                        <td>
                          {{ item.ItemName }}
                          <span *ngIf="item?.sub_type">- {{ item.sub_type }}</span>
                        </td>
                        <td>{{ item.quantity }} {{ item.uom }}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--view details popup screen end-->
  </div>
</div>
